<script setup>

</script>

<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 10.3333V16M16 21.6666H16.0142M30.1667 16C30.1667 23.824 23.824 30.1666 16 30.1666C8.17596 30.1666 1.83333 23.824 1.83333 16C1.83333 8.17595 8.17596 1.83331 16 1.83331C23.824 1.83331 30.1667 8.17595 30.1667 16Z"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>